import {
  API_ERROR,
  INPUT_CHANGEVALUE,
  SELECT_CHANGEVALUE,
  SR_INPUT_CHANGEVALUE,
  SR_SELECT_CHANGEVALUE,
  SI_INPUT_CHANGEVALUE,
  ITEM_QTY_CHANGEVALUE,
  ITEM_UNITES_CHANGEVALUE,
  SI_SELECT_CHANGEVALUE,
  MY_SERVICEREQUEST_LIST,
  SERVICEREQUEST_LIST,
  DEPT_SERVICEREQUEST_LIST,
  ALL_SERVICEREQUEST_LIST,
  SERVICEREQUEST_LIST_SUCCESS,
  SERVICEREQUEST_LIST_COUNT,
  MY_SERVICEREQUEST_LIST_COUNT,
  DEPT_SERVICEREQUEST_LIST_COUNT,
  ALL_SERVICEREQUEST_LIST_COUNT,
  SERVICEREQUEST_LIST_COUNT_SUCCESS,
  PRODUCTS_ROW_REQUEST,
  PRODUCTS_ROW_REQUEST_SUCCESS,
  SELECTED_PRODUCTS_LIST,
  REMOVE_SELECTED_PRODUCT,
  MODEL_OPEN,
  MODEL_CLOSE,
  GET_USER_DEPARTMENT,
  USER_DEPARTMENT_SUCCESS,
  SERVICEREQUEST_ROW_DATA,
  SERVICEREQUEST_ROW_DATA_SUCCESS,
  TOGGLE_ITEM_MENU,
  SERVICEREQUEST_DELETE,
  ITEM_HOD_APPROVAL,
  SR_ITEM_HOD_APPROVAL,
  SRI_STORE_USER_APPROVAL,
  SRI_STORE_HOD_APPROVAL,
  MT_ROW_LOADING,
  C_PRODUCT_IMAGE,
  C_PRODUCT_CHANGEVALUE,
  C_PRODUCT_SELECT_CHANGEVALUE,
  CUSTOM_PRODUCT_ADD,
  CUSTOMPRODUCT_ADD_SUCCESS,
  CHANGE_TOGGALE_TAB,
  SET_PARAMS,
  FILTER_INPUT_CHANGEVALUE,
  FILTER_SELECT_CHANGEVALUE,
  LIST_LAYOUT,
  PRODUCTS_REQUEST_LIST,
  PRODUCTS_REQUEST_LIST_SUCCESS,
  SR_MODEL_LIST_OPEN,
  MODEL_LIST_CLOSE,
  SERVICEREQUEST_ADD,
  SR_DEPT_HOD_APPROVE_ADD,
  ALL_SR_HOD_ITEM_LIST_CHECKED,
  SR_HOD_ITEM_LIST_CHECKED,
  SR_HOD_APPROVE_ADD,
  SERVICEREQUEST_ADD_SUCCESS,
  CHANGE_ITEM_MODEL_OPEN,
  CHANGE_ITEM_MODEL_CLOSE,
  C_PRODUCT_RIGHT_SIDEBAR,
  C_PRODUCT_HIDE_RIGHT_SIDEBAR,
  CHANGE_ACTIVATE_PRODUCT,
  FILTERS_SHOW_RIGHT_SIDEBAR,
  FILTERS_HIDE_RIGHT_SIDEBAR,
  CLEAR_FILTER,
  VIEW_SR_LOG_SHOW_RIGHT_SIDEBAR,
  VIEW_LOG_HIDE_RIGHT_SIDEBAR,
  SR_ITEM_TIME_LINE,
  ITEM_TIME_LINE_SUCCESSFUL,
  PI_ITEM_TIME_LINE,
  PO_ITEM_TIME_LINE,
  IGP_ITEM_TIME_LINE,
  PRODUCT_STORE_QTY,
  PRODUCT_STORE_QTY_SUCCESSFUL,
  PDF_DOWNNLOAD,
  CLEAR_DATA,
  PRODUCT_HISTORY,
  PRODUCT_HISTORY_SUCCESSFUL,
  PRODUCT_HISTORY_MODEL_CLOSE,
  SR_PRODUCT_ITEM_HISTORY_MODEL_OPEN,
  PRODUCT_ITEM_HISTORY_MODEL_CLOSE,
  SR_ITEM_IMAGES_UPLOAD,
  SR_ITEM_UPDATE_IMAGE,
  SERVICE_REQUEST_CLOSE,
  SRQ_FOCUS_POST,
  VIEW_LOG_SR_HIDE_RIGHT_SIDEBAR
} from "./actionTypes";
import moment from "moment";

const initialState = {
  loading: false,
  activeTab: 1,
  error_msg: {},
  productslist: [],
  productsCount: 0,
  listModel: false,
  actionMenu: false,
  selectedItems: [],
  rowdata: {},
  srRowData: {},
  UserDepts: [],
  srCustomItem: [],
  SRcheckedItem: [],
  srPedningItems: [],
  srItemsList: [],
  srRowlistcount: 0,
  srListCount: 0,
  productRowdata: {},
  cPRowData: {},
  filterdata: {},
  Sortvar: {
    id: "REQUEST NO",
    createdon: "CREATED ON",
  },
  dataLoading: false,
  params: {
    srstatus: [0],
    pistatus: [0],
    mistatus: [0],
    no_of_pages: 0,
    page_size: 20,
    page: 1,
    search: "",
    currentSort: "id",
    sortOrder: "-",
  },
  layout: "list",
  Change_item_model: false,
  changeItem: {},
  changeCustomeItem: {},
  showCPRightSidebar: false,
  SRlevel: "DeptHOD",
  activateproduct: false,
  SRFilterlevel: null,
  showFilterRightSidebar: false,
  showViewLogRightSidebar: false,
  itemTimeLine: [],
  srIssueItem: [],
  itemSelectedId: 0,
  selectedPIItemId: 0,
  selectedCQItemId: 0,
  selectedIGPItemId: 0,
  PITimeLineItems: [],
  TimeLineProduct: {},
  PIitemTimeLine: [],
  RFQItemsTimeLine: [],
  CQTimeLineItems: [],
  POItemsTimeLine: [],
  IGPItemsTimeLine: [],
  IGPTimeLine: [],
  productStoreQty: {},
  cPimage: {},
  productHistorylist: [],
  productHistory_model: false,
  PIData: {},
  productItemLoglist: [],
  productItemHistory_model: false,
  SRItemImage: [],
};

const servicerequest = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_DATA:
      state = {
        ...state,
        srRowData: {},
        selectedItems: [],
      };
      break;
    case INPUT_CHANGEVALUE:
      state = {
        ...state,
        rowdata: {
          ...state.rowdata,
          [action.payload.key]: action.payload.value,
        },
      };
      break;
    case SELECT_CHANGEVALUE:
      state = {
        ...state,
        rowdata: {
          ...state.rowdata,
          [action.payload.key]: action.payload.label,
          [action.payload.key2]: action.payload.value,
        },
      };
      break;

    case SR_INPUT_CHANGEVALUE:
      state = {
        ...state,
        srRowData: {
          ...state.srRowData,
          [action.payload.key]: action.payload.value,
        },
      };
      break;
    case SR_SELECT_CHANGEVALUE:
      state = {
        ...state,
        srRowData: {
          ...state.srRowData,
          [action.payload.key]: action.payload.label,
          [action.payload.key2]: action.payload.value,
        },
      };
      break;
    case SI_INPUT_CHANGEVALUE:
      var selectedItems = state.selectedItems.map((p) => {
        if (p.product?.id === action.payload.item.product.id) {
          p.qty = action.payload.value;
        }
        return p;
      });
      state = {
        ...state,
        selectedItems: selectedItems,
      };
      break;

    case SI_SELECT_CHANGEVALUE:
      var selectedItems1 = state.selectedItems.map((p) => {
        if (p.product?.id === action.payload.item.product.id) {
          p.unit = {
            id: action.payload.value,
            name: action.payload.label,
          };
        }
        return p;
      });

      state = {
        ...state,
        selectedItems: selectedItems1,
      };
      break;

    case PRODUCTS_REQUEST_LIST:
      if (action.payload.clearList === true) {
        state.productslist = [];
      }
      state = {
        ...state,
        dataLoading: true,
        loading: true,

        rowdata: {},
      };
      break;
    case PRODUCTS_REQUEST_LIST_SUCCESS:
      var selectedItems_ids = [];
      var productslist = [];
      var noofpages = Math.ceil(action.payload.count / state.params.page_size);
      if (!state.Change_item_model) {
        selectedItems_ids = state.selectedItems.map((p) => {
          return p.product.id;
        });
      } else {
        selectedItems_ids = state.srItemsList.map((p) => {
          return p.product.id;
        });
      }
      productslist = action.payload.results.filter((p) => {
        return selectedItems_ids.indexOf(p.id) === -1;
      });

      state = {
        ...state,
        productslist: [...state.productslist, ...productslist],
        productsCount: action.payload.count,
        // ChangeProductList:
        dataLoading: false,
        params: {
          ...state.params,
          no_of_pages: noofpages,
        },
        loading: false,
        // model: true,
      };
      break;
    case PRODUCTS_ROW_REQUEST:
      state = {
        ...state,
        loading: true,
      };
      break;

    case PRODUCTS_ROW_REQUEST_SUCCESS:
      state = {
        ...state,
        productRowlist: action.payload.response,
        loading: false,
        rowdata: {},
        // model: true,
      };
      break;
    case SELECTED_PRODUCTS_LIST:
      var productslists = state.productslist.filter((p) => {
        return p.id !== action.payload.product_id;
      });

      var item = action.payload;
      state = {
        ...state,

        rowdata: {
          date: moment().format("DD-MM-YYYY"),
        },
        productslist: productslists,
        selectedItems: [
          ...state.selectedItems,
          {
            qty: item.qty,
            unit_id: item.unit_id,
            // unitsLabel: item.unitsLabel,
            date: moment(item.date).format("DD-MM-YYYY"), //item.date,
            make: item.make,
            description: item.description,
            product_id: item.product_id,
            department: { id: item.department.id, name: item.department.name },
            unit: {
              id: item.unit_id,
              name: item.unitsLabel,
            },
            product: {
              id: item.product_id,
              image: item.image,
              name: item.name,
            },
          },
        ],
      };
      break;
    case REMOVE_SELECTED_PRODUCT:
      var selectedItems2 = [];
      if (action.payload.id) {
        selectedItems2 = state.selectedItems.map((item) => {
          if (item.product?.id === action.payload.product.id)
            item.dodelete = true;
          return item;
        });
      } else {
        selectedItems2 = state.selectedItems.filter(
          (p) => p.product?.id !== action.payload.product.id
        );
      }
      state = {
        ...state,
        selectedItems: selectedItems2,
      };
      break;
    case SERVICEREQUEST_ADD:
      state = {
        ...state,
        loading: true,
      };
      break;
    case SERVICEREQUEST_ADD_SUCCESS:
      state = {
        ...state,
        message: action.payload,

        loading: false,
      };
      break;
    case SET_PARAMS:
      state = {
        ...state,
        params: action.payload,
      };
      break;
    case FILTER_INPUT_CHANGEVALUE:
      state = {
        ...state,
        params: {
          ...state.params,
          [action.payload.key]: action.payload.value,
        },
      };
      break;
    case FILTER_SELECT_CHANGEVALUE:
      state = {
        ...state,
        filterdata: {
          ...state.filterdata,
          [action.payload.key]: action.payload.label,
        },
        params: {
          ...state.params,
          [action.payload.key2]: action.payload.value,
        },
      };
      break;
    case SERVICEREQUEST_LIST_COUNT:
      state = {
        ...state,
        loading: true,
      };
      break;
    case MY_SERVICEREQUEST_LIST_COUNT:
      state = {
        ...state,
        loading: true,
      };
      break;
    case DEPT_SERVICEREQUEST_LIST_COUNT:
      state = {
        ...state,
        loading: true,
      };
      break;
    case ALL_SERVICEREQUEST_LIST_COUNT:
      state = {
        ...state,
        loading: true,
      };
      break;
    case SERVICEREQUEST_LIST_COUNT_SUCCESS:
      state = {
        ...state,
        srListCount: action.payload,
        loading: false,
      };

      break;
    case MY_SERVICEREQUEST_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case SERVICEREQUEST_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case DEPT_SERVICEREQUEST_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case ALL_SERVICEREQUEST_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case SERVICEREQUEST_LIST_SUCCESS:
      var noofpages1 = Math.ceil(action.payload.count / state.params.page_size);

      state = {
        ...state,
        srRowList: action.payload.results,
        srRowlistcount: action.payload.count,
        params: {
          ...state.params,
          no_of_pages: noofpages1,
        },
        loading: false,
      };

      break;
    case GET_USER_DEPARTMENT:
      state = {
        ...state,
        // UserDepts: action.payload.UserDepts,
        loading: true,
      };
      break;
    case USER_DEPARTMENT_SUCCESS:
      state = {
        ...state,
        UserDepts: action.payload,
        loading: false,
      };
      break;
    case ITEM_QTY_CHANGEVALUE:
      var QtyChangeItem = [];
      if (action.payload.status === "DeptHod") {
        QtyChangeItem = state.srItemsList.map((p) => {
          if (p.product?.id === action.payload.item.product.id) {
            p.t_qty = action.payload.value;
          }
          return p;
        });
        state = {
          ...state,
          srItemsList: QtyChangeItem,
        };
      }
      if (action.payload.status === "MaterialHod") {
        QtyChangeItem = state.srCustomItem.map((p) => {
          if (p.product?.id === action.payload.item.product.id) {
            p.t_qty = action.payload.value;
          }
          return p;
        });
        state = {
          ...state,
          srCustomItem: QtyChangeItem,
        };
      }

      break;

    case ITEM_UNITES_CHANGEVALUE:
      var UniteChangeItems = [];
      if (action.payload.status === "DeptHod") {
        UniteChangeItems = state.srItemsList.map((p) => {
          if (p.product?.id === action.payload.item.product.id) {
            p.t_unit = {
              id: action.payload.value,
              name: action.payload.label,
            };
          }
          return p;
        });

        state = {
          ...state,
          srItemsList: UniteChangeItems,
        };
      }
      if (action.payload.status === "MaterialHod") {
        UniteChangeItems = state.srCustomItem.map((p) => {
          if (p.product?.id === action.payload.item.product.id) {
            p.t_unit = {
              id: action.payload.value,
              name: action.payload.label,
            };
          }
          return p;
        });

        state = {
          ...state,
          srCustomItem: UniteChangeItems,
        };
      }
      break;
    case SERVICEREQUEST_ROW_DATA:
      state = {
        ...state,
        loading: true,
        Change_item_model: false,
      };
      break;
    case SERVICEREQUEST_ROW_DATA_SUCCESS:
      var UserDeptIds = state.UserDepts.map((dept) => dept.id);
      var customItems = (action.payload.response.sritems || []).filter((item) => {
        if (UserDeptIds.indexOf(item.department.id) === -1) {
          return false;
        }
        item.itemcheck = false;
        return true;
      });
      //  customItems.filter((item) => {
      //   if (item.srstatus === 5) {
      //     return true;
      //   }
      //   return 0;
      // });

      // var srPedningItems = [];
      state.srPedningItems = customItems.filter((item) => {
        return item.srstatus === 3;
      });
      // if (srPedningItems.length != 0) {
      //   state.SRButtons = true;
      // }
      var sr_approvals = [];
      sr_approvals = (action.payload.response.sr_approvals || []).filter(
        (approvale) => {
          if (approvale.srstatus === 3) {
            return approvale.approvedby;
          }
          return 0;
        }
      );
      state = {
        ...state,
        srRowData: {
          ...action.payload.response,
          userDeptApprovedby: sr_approvals,
        },
        srCustomItem: customItems,
        srItemsList: action.payload.response.sritems || [],
        selectedItems: action.payload.response.sritems || [],
        loading: false,
      };
      break;
    case ALL_SR_HOD_ITEM_LIST_CHECKED:
      var SRlistItems = [];
      if (action.payload.checked === true) {
        SRlistItems = state.srCustomItem.map((item) => {
          if (item.srstatus === 3 && item.product.active === true) {
            item.itemcheck = true;
          }
          return item;
        });

        state.SRcheckedItem = SRlistItems.filter((item) => {
          return item.itemcheck;
        });
        state.allItemsCheked = true;
      } else {
        SRlistItems = state.srCustomItem.map((item) => {
          item.itemcheck = false;
          return item;
        });
        state.SRcheckedItem = [];
        state.allItemsCheked = false;
      }
      state = {
        ...state,

        srCustomItem: SRlistItems,
      };
      break;
    case SR_HOD_ITEM_LIST_CHECKED:
      if (action.payload.checked === true) {
        state.srCustomItem[action.payload.index].itemcheck = true;
        state = {
          ...state,
          SRcheckedItem: [...state.SRcheckedItem, { ...action.payload.item }],

          loading: false,
        };
      } else {
        state.srCustomItem[action.payload.index].itemcheck = false;
        var mRcheckedItem = state.SRcheckedItem.filter((p) => {
          return p.id !== action.payload.item.id;
        });

        state = {
          ...state,

          SRcheckedItem: mRcheckedItem,
        };
      }

      if (state.srCustomItem.length === state.SRcheckedItem.length) {
        state.allItemsCheked = true;
      } else {
        state.allItemsCheked = false;
      }

      break;
    case MODEL_OPEN:
      state = {
        ...state,
        loading: true,
        model: true,
        productslist: [],
      };
      break;
    case MODEL_CLOSE:
      state = {
        ...state,
        model: false,
        params: { ...state.params, search: "", page: 1 },
        productslist: [],
        cPRowData: {},
      };
      break;

    case SR_MODEL_LIST_OPEN:
      state = {
        ...state,
        srItemsList: state.srItemsList,
        loading: true,
        listModel: true,
      };
      break;
    case MODEL_LIST_CLOSE:
      state = {
        ...state,
        listModel: false,
      };
      break;
    case TOGGLE_ITEM_MENU:
      var srRowList = state.srRowList?.map((i) => {
        if (i.id === action.payload) {
          i.actionMenu = !i.actionMenu;
        } else {
          i.actionMenu = false;
        }
        return i;
      });

      state = {
        ...state,
        srRowList: srRowList,
      };
      break;

    case SERVICEREQUEST_DELETE:
      state = {
        ...state,
        loading: false,
      };
      break;
    case ITEM_HOD_APPROVAL:
      state = {
        ...state,
        loading: true,
      };
      break;
    case SR_DEPT_HOD_APPROVE_ADD:
      state = {
        ...state,
        loading: true,
      };
      break;

    case SR_ITEM_HOD_APPROVAL:
      state = {
        ...state,
        loading: true,
      };
      break;
    case SRI_STORE_USER_APPROVAL:
      state = {
        ...state,
        loading: true,
      };
      break;
    case SRI_STORE_HOD_APPROVAL:
      state = {
        ...state,
        loading: true,
      };
      break;
    case SR_HOD_APPROVE_ADD:
      state = {
        ...state,
        loading: true,
      };
      break;

    case MT_ROW_LOADING:
      state = {
        ...state,
        // loading: true,
        Change_item_model: false,
        srRowData: {
          ...state.srRowData,
          loading: action.payload,
        },
      };
      break;
    case C_PRODUCT_IMAGE:
      state = {
        ...state,
        cPimage: action.payload.file,
        imagePreviewUrl: action.payload.imagePreviewUrl,
      };
      break;
    case C_PRODUCT_CHANGEVALUE:
      state = {
        ...state,
        cPRowData: {
          ...state.cPRowData,
          [action.payload.key]: action.payload.value,
          deparment_id: state.rowdata.deparment_id,
        },
      };

      break;
    case C_PRODUCT_SELECT_CHANGEVALUE:
      state = {
        ...state,
        cPRowData: {
          ...state.cPRowData,
          [action.payload.key]: action.payload.label,
          [action.payload.key2]: action.payload.value,
        },
      };
      break;

    case CUSTOM_PRODUCT_ADD:
      state = {
        ...state,
        error_msg: {},
        loading: true,
      };
      break;
    case CUSTOMPRODUCT_ADD_SUCCESS:
      if (!state.Change_item_model) {
        state = {
          ...state,
          loading: false,
          selectedItems: [
            ...state.selectedItems,
            {
              description: state.cPRowData.cdescription,
              date:
                state.cPRowData.cdate == null
                  ? moment(new Date()).format("DD-MM-YYYY")
                  : moment(state.cPRowData.cdate).format("DD-MM-YYYY"),
              make: state.cPRowData.cmake,
              qty: state.cPRowData.citem_qty,
              unit: action.payload.response.data.units[0],
              product: action.payload.response.data,
              product_id: action.payload.response.data.id,
              department: {
                id: action.payload.response.data.department.id,
                name: action.payload.response.data.department.name,
              },
            },
          ],
        };
      } else {
        state.changeCustomeItem = action.payload.response;
      }
      break;
    case CHANGE_TOGGALE_TAB:
      state = {
        ...state,

        activeTab: action.payload.tab,
        imagePreviewUrl: "",
        cPRowData: {},
        cPimage: {},
        loading: false,
      };
      break;
    case LIST_LAYOUT:
      state = {
        ...state,
        layout: action.payload,
        loading: false,
      };
      break;
    case CHANGE_ITEM_MODEL_OPEN:
      state = {
        ...state,
        Change_item_model: true,
        changeItem: action.payload.item,
        PIData: action.payload.PIData ? action.payload.PIData : {},

        SRlevel: action.payload.SRlevel,

        loading: false,
      };
      break;
    case CHANGE_ITEM_MODEL_CLOSE:
      state = {
        ...state,
        Change_item_model: false,

        params: { ...state.params, search: "", page: 1 },
        // productslist: [],
        // cPRowData: {},
        loading: false,
      };
      break;
    case CHANGE_ACTIVATE_PRODUCT:
      state = {
        ...state,
        productRowlist: action.payload,
        Change_item_model: true,
        activeTab: 2,
        activateproduct: true,
        SRlevel: "SRHod",
      };
      break;
    case C_PRODUCT_RIGHT_SIDEBAR:
      state = {
        ...state,
        Change_item_model: false,
        changeItem: action.payload.item,
        showCPRightSidebar: !state.showCPRightSidebar,
      };
      break;
    case C_PRODUCT_HIDE_RIGHT_SIDEBAR:
      state = {
        ...state,
        showRightSidebar: false,
      };
      break;
    case FILTERS_SHOW_RIGHT_SIDEBAR:
      state = {
        ...state,
        SRFilterlevel: action.payload.SRFilterlevel,
        showFilterRightSidebar: !state.showFilterRightSidebar,
      };
      break;
    case FILTERS_HIDE_RIGHT_SIDEBAR:
      state = {
        ...state,
        SRFilterlevel: null,
        showFilterRightSidebar: false,
      };
      break;
    case CLEAR_FILTER:
      state = {
        ...state,
        filterdata: {},
      };
      break;
    case VIEW_SR_LOG_SHOW_RIGHT_SIDEBAR:
      state = {
        ...state,

        showViewLogRightSidebar: !state.showViewLogRightSidebar,
      };
      break;
    case VIEW_LOG_SR_HIDE_RIGHT_SIDEBAR:
      state = {
        ...state,
        itemTimeLine: [],
        srIssueItem: [],
        PIitemTimeLine: [],
        RFQItemsTimeLine: [],
        POItemsTimeLine: [],
        IGPItemsTimeLine: [],
        IGPTimeLine: [],
        selectedPIItemId: 0,
        selectedCQItemId: 0,
        selectedIGPItemId: 0,
        showViewLogRightSidebar: false,
      };
      break;
    case SR_ITEM_TIME_LINE:
      state = {
        ...state,
        itemTimeLine: [],
        srIssueItem: [],
        PIitemTimeLine: [],
        RFQItemsTimeLine: [],
        POItemsTimeLine: [],
        IGPItemsTimeLine: [],
        IGPTimeLine: [],
        selectedPIItemId: 0,
        selectedCQItemId: 0,
        selectedIGPItemId: 0,
        itemSelectedId: action.payload.SRItemId,
        loading: true,
      };
      break;
    case ITEM_TIME_LINE_SUCCESSFUL:
      var srItemCreate = {
        type: "SRCreate",
        createdon: action.payload.createdon,
        product:
          action.payload.sri_approvals.length === 0
            ? action.payload.product
            : action.payload.sri_approvals[0].f_product,
        qty:
          action.payload.sri_approvals.length === 0
            ? action.payload.qty
            : action.payload.sri_approvals[0].f_qty,
        unit:
          action.payload.sri_approvals.length === 0
            ? action.payload.unit
            : action.payload.sri_approvals[0].f_unit,
      };

      var SRitemTimeLine = action.payload.sri_approvals.map((item) => {
        item.type = "SRlevel";
        return item;
      });
   
      var srIssueItemCreate = {};
      // if (action.payload.miitems.length > 0) {
      //   srIssueItemCreate = {
      //     type: "SRIssueCreate",
      //     srissueCode: action.payload.miitems[0].materialissue.code,
      //     createdby: action.payload.miitems[0].materialissue.createdby,
      //     createdon: action.payload.miitems[0].materialissue.createdon,
      //     location: action.payload.miitems[0].materialissue.location,
      //     product: action.payload.miitems[0].product,
      //     qty: action.payload.miitems[0].qty,
      //     unit: action.payload.miitems[0].unit,
      //   };
      // }
      var PIItem = [];

      if (action.payload.siisri.length > 0) {
        PIItem.push({
          type: "PICreate",
          // piitem: PIitem.piitem,
        });
      }
      state = {
        ...state,
        loading: false,
        itemTimeLine: [srItemCreate, ...SRitemTimeLine],
        srIssueItem: [srIssueItemCreate, ...PIItem],
        PITimeLineItems: action.payload.siisri,
        TimeLineProduct: action.payload.product,
      };
      break;

    case PI_ITEM_TIME_LINE:
      var PIItemCreate = {
        type: "PIICreate",
        createdon: action.payload.PIItem.siitem.serviceindent.createdon,
        createdby: action.payload.PIItem.siitem.serviceindent.createdby,
        product: state.TimeLineProduct,
        qty: action.payload.PIItem.siitem.qty,
        unit: action.payload.PIItem.siitem.unit,
      };
      var PIitemTimeLine = action.payload.PIItem.siitem.sii_approvals.map(
        (item) => {
          return {
            ...item,
            type: "PIIApproval",
            product: state.TimeLineProduct,
          };
        }
      );
      var PITimeLine =
        action.payload.PIItem.siitem.serviceindent.si_approvals?.map((PI) => {
          return {
            ...PI,
            type: "PIApproval",
            purchaseindent_code:
              action.payload.PIItem.siitem.serviceindent.code,
            product: state.TimeLineProduct,
          };
        });
      var RFQItems = {};
      var CQItem = [];
      if (action.payload.PIItem.siitem.srfqisii.length > 0) {
        var rfqdata = action.payload.PIItem.siitem.srfqisii[0];
        RFQItems = {
          type: "RFQICreate",
          createdon: rfqdata.srfqitem.servicerequestforquotation.createdon,
          createdby: rfqdata.srfqitem.servicerequestforquotation.createdby,
          product: state.TimeLineProduct,
          qty: rfqdata.srfqitem.qty,
          unit: rfqdata.srfqitem.unit,
          RFQ_code: rfqdata.srfqitem.servicerequestforquotation.code,
        };

        if (rfqdata.srfqitem.scqitem.length > 0) {
          CQItem.push({
            type: "CQCreate",
            // piitem: PIitem.piitem,
          });
        }
        state.CQTimeLineItems = rfqdata.srfqitem.scqitem;
      }

      state = {
        ...state,
        loading: false,
        POItemsTimeLine: [],
        selectedPIItemId: action.payload.PIItem.id,
        PIitemTimeLine: [PIItemCreate, ...PIitemTimeLine, ...PITimeLine],
        RFQItemsTimeLine: [RFQItems, ...CQItem],
      };
      break;

    case PO_ITEM_TIME_LINE:
      var POItemCreate = {
        type: "POICreate",
        createdon: action.payload.POItem.woitem[0].createdon,
        createdby: action.payload.POItem.woitem[0].workorder.createdby,
        product: state.TimeLineProduct,
        qty: action.payload.POItem.woitem[0].qty,
        unit: action.payload.POItem.woitem[0].unit,
        price: action.payload.POItem.woitem[0].price,
        gross: action.payload.POItem.woitem[0].gross,
        purchaseorder_code: action.payload.POItem.woitem[0].workorder.code,
      };
      // var RFQItemCreate = action.payload.rfqipii.map((RFQitem) => {
      //   return { ...RFQitem.rfqitem, type: "RFQCreate" };
      // });

      var IGPItems = [];
      if (action.payload.POItem.woitem[0]?.grn2items?.length > 0) {
        IGPItems.push({
          type: "IGPCreate",
        });
      }
      state.IGPTimeLine = action.payload.POItem.woitem[0]?.grn2items;

      state = {
        ...state,
        selectedCQItemId: action.payload.POItem.id,
        loading: false,
        POItemsTimeLine: [POItemCreate, ...IGPItems],
      };
      break;
    case IGP_ITEM_TIME_LINE:
      var IGPItemCreate = {
        type: "IGPICreate",
        createdon: action.payload.IGPItem.goodsreceivednote2_createdon,
        // createdby: action.payload.POItem.poitem[0].purchaseorder.createdby,
        personname: action.payload.IGPItem.goodsreceivednote2_personname,
        vehicleno: action.payload.IGPItem.goodsreceivednote2_vehicleno,
        igpcode: action.payload.IGPItem.goodsreceivednote2_code,
      };

      state = {
        ...state,
        selectedIGPItemId: action.payload.IGPItem.id,
        loading: false,
        IGPItemsTimeLine: [IGPItemCreate],
      };
      break;

    case PRODUCT_STORE_QTY:
      state = {
        ...state,
        loading: false,
      };
      break;
    case PRODUCT_STORE_QTY_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        productStoreQty: action.payload,
      };
      break;
    case PDF_DOWNNLOAD:
      state = {
        ...state,
        loading: false,
      };
      break;
    case PRODUCT_HISTORY:
      state = {
        ...state,
        loading: true,
      };
      break;

    case PRODUCT_HISTORY_SUCCESSFUL:
      state = {
        ...state,
        productHistorylist: action.payload.results,
        loading: false,
        productHistory_model: true,
        // model: true,
      };
      break;
    case PRODUCT_HISTORY_MODEL_CLOSE:
      state = {
        ...state,
        loading: false,
        productHistory_model: false,
      };
      break;
    case SR_PRODUCT_ITEM_HISTORY_MODEL_OPEN:
      state = {
        ...state,
        productItemLoglist: action.payload.data,
        loading: false,
        productItemHistory_model: true,
        // model: true,
      };
      break;
    case PRODUCT_ITEM_HISTORY_MODEL_CLOSE:
      state = {
        ...state,
        loading: false,
        productItemHistory_model: false,
      };
      break;
    case SR_ITEM_IMAGES_UPLOAD:
      state = {
        ...state,
        loading: false,
        SRItemImage: [
          ...state.SRItemImage,
          {
            Product_id: action.payload.ProductId,
            ItemImages: action.payload.srItemImage,
          },
        ],
      };
      break;
    case SR_ITEM_UPDATE_IMAGE:
      state = {
        ...state,
        loading: false,
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        loading: false,
        error_msg: action.payload,
      };
      break;
    case SERVICE_REQUEST_CLOSE:
      state = {
        ...state,
        loading: false,
      };
      break;
    case SRQ_FOCUS_POST:
      state = {
        ...state,
        loading: false,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};
export default servicerequest;
